import React, { useState } from "react";
import { Modal, Progress, Button, Divider, Input, Select } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { LuBuilding2, LuDollarSign } from "react-icons/lu";
import { BsPerson } from "react-icons/bs";
import { MdOutlineVilla } from "react-icons/md";
import { FiHome } from "react-icons/fi";
import { FaRegMap } from "react-icons/fa";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { IoMdTrendingUp } from "react-icons/io";

const ViewEnquiry = ({ open, onClose, enquiry }) => {
  const [step, setStep] = useState(1);
  if (!enquiry) return null;

  const answers = {
    propertyType: enquiry.property_type,
    purpose: enquiry.purpose,
    budget: enquiry.budget,
    // locations: enquiry.locations || [],
    timeline: enquiry.timeline,
    name: enquiry.full_name,
    phone: enquiry.phone,
    email: enquiry.email,
    source: enquiry.source,
  };

  const QUIZ_OPTIONS = {
    propertyType: [
      { label: "Flats", icon: LuBuilding2 },
      { label: "Bunglows", icon: FiHome },
      { label: "Plot", icon: FaRegMap },
      { label: "Weekend Villa & Plot", icon: MdOutlineVilla },
    ],

    purpose: [
      { label: "Personal Use", icon: FiHome },
      { label: "Investment", icon: IoMdTrendingUp },
      { label: "Selling a Property", icon: LuDollarSign },
    ],
    budget: [
      { label: "Under ₹1 Cr", icon: LuDollarSign },
      { label: "₹1–2 Cr", icon: LuDollarSign },
      { label: "₹2–4 Cr", icon: LuDollarSign },
      { label: "₹4 Cr+", icon: LuDollarSign },
      { label: "Flexible", icon: AiOutlineQuestionCircle },
    ],
    locations: [
      { label: "Science City" },
      { label: "Thaltej" },
      { label: "Sindhubhavan Road" },
      { label: "Bopal" },
      { label: "Open to Suggestions" },
    ],
    timeline: [
      { label: "Immediately", icon: ClockCircleOutlined },
      { label: "1–3 Months", icon: BsPerson },
      { label: "3–6 Months", icon: BsPerson },
      { label: "Just Exploring", icon: AiOutlineQuestionCircle },
    ],
  };

  const renderOptions = (
    options,
    valueKey,
    isMulti = false,
    hideIcon = false
  ) =>
    options.map(({ label, icon: Icon }) => {
      const isActive = isMulti
        ? answers[valueKey]?.includes(label)
        : answers[valueKey] === label;

      return (
        <div
          key={label}
          className={`quiz-option ${isActive ? "active" : ""}`}
          style={{ cursor: "default" }}
        >
          {!hideIcon && Icon && (
            <span className="quiz-icon">
              <Icon />
            </span>
          )}
          <span className="quiz-label">{label}</span>
        </div>
      );
    });

  return (
    <Modal
      title="View Enquiry Details"
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
    >
      <div className="quiz-modal">
        {/* HEADER */}
        <div className="quiz-header">
          <h3>Find Your Ideal Property</h3>
          <Progress
            percent={(step / 5) * 100}
            showInfo={false}
            strokeColor="#1c3988"
          />
          <span className="quiz-step">Step {step} of 5</span>
        </div>

        <Divider />

        {/* BODY */}
        <div className="quiz-body" style={{ pointerEvents: "none" }}>
          {step === 1 && (
            <>
              <h4>What are you looking for?</h4>
              <div className="quiz-options">
                {renderOptions(QUIZ_OPTIONS.propertyType, "propertyType")}
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <h4>What's the purpose?</h4>
              <div className="quiz-options">
                {renderOptions(QUIZ_OPTIONS.purpose, "purpose")}
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <h4>What's your budget range?</h4>
              <div className="quiz-options">
                {renderOptions(QUIZ_OPTIONS.budget, "budget")}
              </div>
            </>
          )}

          {/* {step === 4 && (
            <>
              <h4>Preferred locations?</h4>
              <div className="quiz-options">
                {renderOptions(QUIZ_OPTIONS.locations, "locations", true, true)}
              </div>
            </>
          )} */}

          {step === 4 && (
            <>
              <h4>When do you plan to make a decision?</h4>
              <div className="quiz-options">
                {renderOptions(QUIZ_OPTIONS.timeline, "timeline")}
              </div>
            </>
          )}

          {/* STEP 5 — READ ONLY */}
          {step === 5 && (
            <>
              <h4>Contact Details</h4>

              <div className="quiz-field">
                <label className="quiz-label-text">Name</label>
                <Input value={answers.name} />
              </div>

              <div className="quiz-field">
                <label className="quiz-label-text">Phone</label>
                <Input value={answers.phone} />
              </div>

              <div className="quiz-field">
                <label className="quiz-label-text">Email</label>
                <Input value={answers.email} />
              </div>

              <div className="quiz-field">
                <label className="quiz-label-text">Source</label>
                <Select value={answers.source} style={{ width: "100%" }} />
              </div>
            </>
          )}
        </div>

        <Divider />

        {/* FOOTER */}
        <div className="quiz-footer">
          <Button
            type="link"
            disabled={step === 1}
            onClick={() => setStep(step - 1)}
          >
            Back
          </Button>

          {step < 5 ? (
            <Button type="primary" onClick={() => setStep(step + 1)}>
              Next
            </Button>
          ) : (
            <Button type="primary" onClick={onClose}>
              Close
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ViewEnquiry;
